// extracted by mini-css-extract-plugin
export default {"main-document":"AccessDeniedModule_main-document__r08Kc","img":"AccessDeniedModule_img__5MzGh"};